//---------------------------------------------------
//  Nom du fichier : SearchSection.js 
//
//  Description: Component qui permet de rechercher un utilisateur par son nom d'usager
//               Permet de chercher une publication par son titre et de filtrer selon sa difficulté
//
//  Auteur: Alek Del Balso
//---------------------------------------------------

import React, { useEffect, useState } from 'react';
import './btn.css';
import './SearchSection.css';
import { Publication } from './pageProfil';
import Recherche from './Recherche.js';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Slider from '@mui/material/Slider';
import { american, european, gradeToSortOrder } from './grades.js';
import { useTranslation } from "react-i18next";
import { callAPI } from './callAPI.js';

//https://mui.com/ pour le slider
function SearchSection({set_publication, showSearch, grade_type, setShowSearch, position}) {
  const { t } = useTranslation();
  const [publications, setPublications] = useState([])
  const [allPublications, setAllPublications] = useState([])
  const [searchingPost, SetSearchingPost] = useState(true)

  const onType = (data) => { 
    setPublications(data)
    setAllPublications(data)
  }

  const get_all_publications = () => { 

    let form = new FormData()
    form.append("type", "get_all_publication_for_search")
    callAPI("read", form)
    .then((data) => {
        setAllPublications(data.result)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });

  }

  const get_closest = () => { 
    if(!position){
      alert(t("create_publication_no_location"))
      return
    }

    let form = new FormData()
    form.append("type", "search_from_position")
    form.append("lat", position.lat)
    form.append("lng", position.lng)
    callAPI("read", form)
    .then((data) => {
        setAllPublications(data.result)
    })
    .catch((error) => {
        console.error("API call failed:", error);
    });

  }

  //GRADE RANGE
  const max = grade_type == "american" ? american.length-1: european.length-1
  const [gradeRange, setGradeRange] = useState([0, max]);
  let gardeMarks = [];

  if(grade_type == "american") gardeMarks = [{value: 0,label: 'VB',},{value: 18,label: 'v17',},];
  else gardeMarks = [{value: 0,label: '3',},{value: 23,label: '9A',},];
  
  function valueLabelFormat(value) {
    return grade_type == "american" ? american[value]: european[value] ;
  }

  //ACHIEVED RANGE
  const maxAchieved = 50
  const [achieveRange, setAchieveRange] = useState([0, maxAchieved]);
  let achievedMarks = [{value: 0,label: '0',},{value: maxAchieved,label: maxAchieved,},];



  useEffect(() => {
    const newPub = allPublications.filter(pub => pub.nb_achieved >= achieveRange[0] && pub.nb_achieved <= achieveRange[1] ) 

      let min = gradeToSortOrder[grade_type == "american" ? american[gradeRange[0]]: european[gradeRange[0]]]
      let max = gradeToSortOrder[grade_type == "american" ? american[gradeRange[1]]: european[gradeRange[1]]]

      const final = newPub.filter(pub => pub.sort_order >= min && pub.sort_order <= max ) 
      setPublications(final) 
  },[gradeRange, achieveRange,allPublications])

  const [alignment, setAlignment] = useState('post');
  const handleAlignment = (
    event,
    newAlignment
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      SetSearchingPost(newAlignment == 'post')
    }
  };
  let sectionStyle = "SavedSection" + (showSearch ? " activeSearchSection" : "")
  return (
    <div className={sectionStyle} style={{overflowY: "auto", scrollbarWidth: "none"}}>
      <span id="quit" className="material-symbols-outlined" onClick={() => { setShowSearch(false) }} style={{ cursor: 'pointer' }}>close</span>
      {searchingPost ? <Recherche setter={onType} showResult={false} id="searchSectionInput"/> : <Recherche/>}
      
    <ToggleButtonGroup
        value={alignment}
        exclusive
        onChange={handleAlignment}
        aria-label="text alignment"
      >
        <ToggleButton value="post" className='search_section_btn' aria-label="left aligned">
          {t('post')}
        </ToggleButton>
        <ToggleButton value="user" className='search_section_btn' aria-label="centered">
          {t('users')}
        </ToggleButton>
      </ToggleButtonGroup>

      { searchingPost && 
        <div className='SliderBox'>
          <p>{t('search_grade')}</p>
          <Slider
            value={gradeRange}
            onChange={(e,newValue) => {setGradeRange(newValue);}}
            valueLabelDisplay="auto"
            marks={gardeMarks}
            min={0}
            max={max}
            valueLabelFormat={valueLabelFormat}
          />  

          <p>{t('search_achived')}</p>
          <Slider
            value={achieveRange}
            onChange={(e,newValue) => {setAchieveRange(newValue);}}
            valueLabelDisplay="auto"
            marks={achievedMarks}
            min={0}
            max={maxAchieved}
          /> 

          <div className='get_all' onClick={get_all_publications}>{t('search_all')}</div>
          <div className='get_all second' onClick={get_closest}>{t('search_closest')}</div>
        </div>
      }

      { publications.length > 0 && searchingPost &&
        publications.map((num) => (
          <Publication grade={num.grade} title={num.title} imageUrl={num.file_path} id={num.id} setPublication={set_publication} className={true} key={num.id} gradeType={grade_type} />
        ))
      }
    </div>
  );
}

export default SearchSection;